import React from 'react';
import {RocketLaunch} from "../icons/RocketLaunchIcon";
import classNames from "classnames";
import {useDsManager} from "@stores/AppStateContext";

import {isFreePlan} from "@stores/client";


import "./RestrictedNumberPicker.css"


interface RestrictedNumberPickerProps {
    numbers: Array<{ value: number; onPremium: boolean }>;
    selectedNumber: number;
    setSelectedNumber: (selectedNumber: number) => void;
}

export const RestrictedNumberPicker: React.FC<RestrictedNumberPickerProps> = (
    {
        numbers,
        selectedNumber,
        setSelectedNumber,
    }
) => {
    const dsManager = useDsManager();
    const subscription_plan = dsManager!.clientAR?.row?.subscription_plan;

    return (
        <div className="RestrictedNumber__block">
            {numbers.map((item, index) => {
                const isDisabled = isFreePlan(subscription_plan) && item.onPremium;
                return (
                    <span
                        key={index}
                        className={classNames({
                            "RestrictedNumberPicker__number body-large": true,
                            "RestrictedNumberPicker__number--active": selectedNumber === item.value,
                            "RestrictedNumberPicker__number--disabled": isFreePlan(subscription_plan) && item.onPremium,
                        })}
                        onClick={() => {
                            if (!isDisabled) {
                                setSelectedNumber(item.value);
                            }
                        }}
                    >
                        {item.value}
                        {item.onPremium && isFreePlan(subscription_plan) ? <RocketLaunch size={20} className="RestrictedNumberPicker__icon"/> : null}
                    </span>
                );
            })}
        </div>
    );
};
